'use strict';

var queueMicrotask = require('queue-microtask');

module.exports = function (fn) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (args.length === 0) {
    queueMicrotask(fn);
  } else {
    queueMicrotask(function () {
      return fn.apply(void 0, args);
    });
  }
};